module.exports = __webpack_public_path__ + "img/6ffdf7d581f4c640af45393b5bf163a4.d5d726d4.png";